// extracted by mini-css-extract-plugin
module.exports = {"follow-heart":"style_follow-heart__MtQci","image-mask-lower":"style_image-mask-lower__3vdrH"};